var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pet)?_c('div',[_c('h1',[_vm._v(_vm._s(_vm.pet.name)+" ("+_vm._s(_vm.$route.params.species)+")")]),_c('p',[_vm._v("Age: "+_vm._s(_vm.pet.age))]),_c('p',[_vm._v("Breed: "+_vm._s(_vm.pet.breed))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }